import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=68e595c4&scoped=true"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"
import style0 from "./CarouselItem.vue?vue&type=style&index=0&id=68e595c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e595c4",
  null
  
)

export default component.exports